export class Weapon {
    name: string;
    attack: number;
    defense: number;

    constructor(name: string, attack: number, defense: number) {
        this.name = name;
        this.attack = attack;
        this.defense = defense;
    }
}